import React, { useState, useEffect, useRef } from 'react'
import { View, KeyboardAvoidingView, ImageBackground } from 'react-native'
import styled from 'styled-components/native'
import Constants from 'expo-constants'
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen'
import { LinearGradient } from 'expo-linear-gradient'
import Svg, { G, Polygon, Path } from 'react-native-svg'
import secrets from '../../config/secrets'
import i18n from '../../services/i18n'
import DebugInfo from './DebugInfo'

const ConnectPhone = props => {
  return (
    <View style={props.style}>
      <Header>
        <StyledImageBackground
          source={require('../../../assets/bg.png')}
          resizeMode="cover"
        >
          <StyledGradient
            colors={['rgba(28, 29, 56, 0)', 'rgba(28, 29, 56, 0.85)', '#1c1d38', '#1c1d38']}
            locations={[0.02, 0.57, 0.86, 1]}
          />
          <IconWrapper><LogoIcon /></IconWrapper>
        </StyledImageBackground>
      </Header>
      <Wrapper behavior={props.behavior} contentContainerStyle={{ flex: 1 }}>
        <Info>
          <Title>{i18n.t('app.title')}</Title>
          {
            props.errorMessage
            ? <ErrorMessage>{props.errorMessage}</ErrorMessage>
            : <Desc>{i18n.t('app.description')}</Desc>
          }
          <CodeInput
            placeholder={i18n.t('app.type_code')}
            placeholderTextColor="rgba(28, 29, 56, 0.4)"
            value={props.token}
            onChangeText={props.onChangeText}
          />
          <SubmitButton onPress={props.onSubmit}>
            <SubmitText>{i18n.t('app.submit')}</SubmitText>
          </SubmitButton>
        </Info>
      </Wrapper>
      { props.debugging && <DebugInfo /> }
    </View>
  )
}

const StyledImageBackground = styled.ImageBackground`
  height: 100%;
  width: 100%;
  overflow: hidden;
  flex: 1 1 auto;
`

const StyledGradient = styled(LinearGradient)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

const IconWrapper = styled.View`
  position: absolute;
  bottom: 90px;
  left: 0;
  right: 0;
  flex: 1;
  align-items: center;
`

const LogoIcon = () => (
  <Svg width="220px" height="50px" viewBox="0 0 220 50">
      <G stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <G transform="translate(-77.000000, -470.000000)">
              <G transform="translate(77.000000, 470.000000)">
                  <G transform="translate(61.000000, 0.000000)" fill="#2BC4B6">
                      <Path d="M15.582,18.6075949 C14.946,18.2278481 14.6916,17.5316456 14.6916,16.5822785 C14.6916,14.9367089 15.9636,14.1139241 18.5076,14.1139241 L29.1288,14.1139241 L29.1288,0.0632911392 L16.218,0.0632911392 C11.2572,0.0632911392 7.3776,1.39240506 4.6428,3.98734177 C1.908,6.58227848 0.5088,10.3164557 0.5088,15.0632911 L0.5088,34.556962 C0.5088,39.4936709 1.9716,43.2278481 4.8336,45.8860759 C7.7592,48.4810127 11.9568,49.8101266 17.4264,49.8101266 L29.0652,49.8101266 L29.0652,36.5822785 L19.08,36.5822785 C17.3628,36.5822785 16.218,36.3924051 15.6456,36.0759494 C15.0732,35.7594937 14.8188,35.0632911 14.8188,34.0506329 C14.8188,33.1012658 15.0732,32.4683544 15.6456,32.0886076 C16.218,31.7088608 17.1084,31.5189873 18.444,31.5189873 L29.256,31.5189873 L29.256,19.1772152 L18.8892,19.1772152 C17.2992,19.1772152 16.218,18.9873418 15.582,18.6075949 Z M66.462,23.1012658 C70.1508,20.3164557 71.9952,16.835443 71.9952,12.6582278 C71.9952,4.24050633 66.5892,0 55.8408,0 L37.7148,0 L37.7148,49.6835443 L47.4456,49.6835443 L47.4456,49.6835443 L55.332,49.6835443 L55.332,49.6835443 L57.6852,49.6835443 C60.6744,49.6835443 63.0276,49.4303797 64.8084,48.9240506 C66.5892,48.4177215 68.1792,47.5316456 69.7692,46.2025316 C72.8856,43.4810127 74.4756,39.8734177 74.4756,35.3797468 C74.4756,29.556962 71.8044,25.443038 66.462,23.1012658 Z M52.5336,13.4177215 L55.2684,13.4177215 C57.7488,13.4177215 58.9572,14.3037975 58.9572,16.0126582 C58.9572,17.8481013 57.6216,18.7974684 54.9504,18.7974684 L52.5336,18.7974684 L52.5336,13.4177215 Z M60.5472,36.4556962 C59.9112,36.835443 58.8936,37.0253165 57.4308,37.0253165 L55.332,37.0253165 L55.332,37.0253165 L52.5336,37.0253165 L52.5336,32.0253165 L54.8868,32.0253165 L54.8868,32.0886076 L57.7488,32.0886076 C60.2292,32.0886076 61.5012,32.9113924 61.5012,34.4936709 C61.5012,35.3797468 61.1832,36.0759494 60.5472,36.4556962 Z M135.5316,0.0632911392 L147.0432,25.9493671 L158.4276,0.0632911392 L135.5316,0.0632911392 Z M121.8576,0.0632911392 C118.614,0.0632911392 115.5612,0.886075949 117.978,6.26582278 C122.112,15.5696203 129.4896,32.2151899 129.4896,32.2151899 L129.4896,49.8101266 L144.372,49.8101266 L144.372,32.5316456 L129.4896,0.0632911392 L121.8576,0.0632911392 Z M108.8832,23.1012658 C112.572,20.3164557 114.4164,16.835443 114.4164,12.6582278 C114.4164,4.24050633 109.0104,0 98.262,0 L80.136,0 L80.136,49.6835443 L89.8668,49.6835443 L89.8668,49.6835443 L97.7532,49.6835443 L97.7532,49.6835443 L100.1064,49.6835443 C103.0956,49.6835443 105.4488,49.4303797 107.2296,48.9240506 C109.0104,48.4177215 110.6004,47.5316456 112.1904,46.2025316 C115.3068,43.4810127 116.8968,39.8734177 116.8968,35.3797468 C116.8968,29.556962 114.2256,25.443038 108.8832,23.1012658 Z M95.0184,13.4177215 L97.7532,13.4177215 C100.2336,13.4177215 101.442,14.3037975 101.442,16.0126582 C101.442,17.8481013 100.1064,18.7974684 97.4352,18.7974684 L95.0184,18.7974684 L95.0184,13.4177215 Z M103.032,36.4556962 C102.396,36.835443 101.3784,37.0253165 99.9156,37.0253165 L97.8168,37.0253165 L97.8168,37.0253165 L95.0184,37.0253165 L95.0184,32.0253165 L97.3716,32.0253165 L97.3716,32.0886076 L100.2336,32.0886076 C102.714,32.0886076 103.986,32.9113924 103.986,34.4936709 C103.9224,35.3797468 103.6044,36.0759494 103.032,36.4556962 Z"></Path>
                  </G>
                  <G transform="translate(43.000000, 0.000000)" fill="#2BC4B6">
                      <Polygon points="0.492307692 0.381818182 8.61538462 20.8727273 15.8769231 0.381818182"></Polygon>
                  </G>
                  <G fill="#FFFFFF">
                      <Path d="M37.0363636,0.379746835 C37.0363636,0.379746835 35.1909091,0.379746835 30.6727273,0.379746835 C27.6818182,0.379746835 20.7454545,0.189873418 23.8636364,7.91139241 C29.0818182,20.7594937 40.6,49.4303797 40.6,49.4303797 C40.6,49.4303797 48.7454545,28.6075949 48.5545455,28.1012658 C41.6818182,11.3291139 37.0363636,0.379746835 37.0363636,0.379746835 Z M8.14545455,0.316455696 C5.15454545,0.316455696 -1.78181818,0.126582278 1.33636364,7.84810127 C6.55454545,20.6962025 18.0727273,49.3670886 18.0727273,49.3670886 C18.0727273,49.3670886 26.2181818,28.5443038 26.0272727,28.0379747 C19.1545455,11.3291139 14.5090909,0.379746835 14.5090909,0.379746835 C14.5090909,0.379746835 12.6636364,0.316455696 8.14545455,0.316455696 Z"></Path>
                  </G>
              </G>
          </G>
      </G>
  </Svg>
)

const SectionContainer = styled.View`
  flex: 1;
`

const Header = styled.View`
  flex: 1 1 auto;
`

const Wrapper = styled.KeyboardAvoidingView`
  flex: 0 0 281px;
`

const Info = styled.View`
  flex: 1;
  padding: 20px;
  background-color: #ffffff;
`

const Title = styled.Text`
  font-family: Gilroy-SemiBold;
  font-size: 28px;
  text-align: center;
  color: #1c1d38;
  margin-top: 8px;
`

const Desc = styled.Text`
  opacity: 0.6;
  font-family: Gilroy-Regular;
  font-size: 20px;
  line-height: 22px;
  text-align: center;
  color: #1c1d38;
  margin-top: 17px;
`

const ErrorMessage = styled(Desc)`
  color: red;
  font-size: 16px;
  margin-top: 12px;
  margin-bottom: -17px;
`

const CodeInput = styled.TextInput`
  border-radius: 11px;
  background-color: rgba(207, 207, 211, 0.27);
  height: 41px;
  padding: 7px 14px;
  margin-top: 27px;
  color: #757f99;
  font-size: 18px;
  font-family: Gilroy-Regular;
`

const SubmitButton = styled.TouchableOpacity`
  border-radius: 11px;
  padding: 14px 18px;
  margin-top: 13px;
  background: #ff7e5c;
  display: flex;
  align-items: center;
  justify-content: center;
`

const SubmitText = styled.Text`
  color: #ffffff;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
`

export default styled(ConnectPhone)`
  flex: 1;
  background-color: #1C1D38;
`
